// Frappe Chat desk/web entry: iframe UI (fixed_chat_preview) + legacy welcome screen for unverified guests.
import { get_settings } from './components/chat_utils';
import ChatBubble from './components/chat_bubble';
import ChatWelcome from './components/chat_welcome_screen';

frappe.provide('frappe.Chat');
frappe.provide('frappe.Chat.settings');

/** Spawns chat widget: shell + optional iframe to new template or ChatWelcome for guests. */
frappe.Chat = class {
	constructor() {
		this.setup_app();
	}

	create_app() {
		this.$app_element = $(document.createElement('div'));
		this.$app_element.addClass('chat-app');
		this.$chat_container = $(document.createElement('div'));
		this.$chat_container.addClass('chat-container');
		$('body').append(this.$app_element);
		this.is_open = false;

		this.$chat_element = $(document.createElement('div'))
			.addClass('chat-element')
			.hide();

		this.$chat_element.append(this.$chat_container);
		this.$chat_element.appendTo(this.$app_element);

		this.chat_bubble = new ChatBubble(this);
		this.chat_bubble.render();

		const navbar_icon_html = `
        <li class='nav-item dropdown dropdown-notifications 
          dropdown-mobile chat-navbar-icon' title="Show Chats" >
          ${frappe.utils.icon('small-message', 'md')}
          <span class="badge" id="chat-notification-count"></span>
        </li>
    `;

		if (this.is_desk === true) {
			$('header.navbar > .container > .navbar-collapse > ul').prepend(navbar_icon_html);
		}
		this.setup_events();
	}

	mount_iframe() {
		this.$chat_container.empty();
		const me = this;
		const $iframe = $('<iframe>', {
			class: 'chat-widget-iframe',
			src: '/assets/chat/fixed_chat_preview/index.html',
			title: __('Chat'),
		});
		$iframe.attr('allow', 'clipboard-read; clipboard-write');
		$iframe.on('load', function () {
			me.notify_iframe_shell(!!me.is_open);
		});
		this.$chat_container.append($iframe);
	}

	/** Tell embedded UI whether the desk chat panel is visible (iframe may stay mounted while hidden). */
	notify_iframe_shell(open) {
		const el = this.$chat_container.find('iframe.chat-widget-iframe')[0];
		if (!el || !el.contentWindow) {
			return;
		}
		try {
			el.contentWindow.postMessage({ type: 'frappe-chat-shell', open: !!open }, '*');
		} catch (e) {
			/* ignore */
		}
	}

	async setup_app() {
		try {
			const token = localStorage.getItem('guest_token') || '';
			const res = await get_settings(token);
			this.is_admin = res.is_admin;
			this.is_desk = 'desk' in frappe;

			if (res.enable_chat === false || (!this.is_desk && this.is_admin)) {
				return;
			}

			this.create_app();
			await frappe.socketio.init(res.socketio_port);

			frappe.Chat.settings = {};
			frappe.Chat.settings.user = res.user_settings;
			frappe.Chat.settings.unread_count = 0;

			if (res.is_admin || res.is_verified) {
				this.mount_iframe();
			} else {
				this.chat_welcome = new ChatWelcome({
					$wrapper: this.$chat_container,
					profile: {
						name: res.guest_title,
						is_admin: res.is_admin,
						chat_status: res.chat_status,
					},
				});
				this.chat_welcome.render();
			}
		} catch (error) {
			console.error(error);
		}
	}

	show_chat_widget() {
		this.is_open = true;
		this.notify_iframe_shell(true);
		this.$chat_element.fadeIn(250);
	}

	hide_chat_widget() {
		this.is_open = false;
		this.notify_iframe_shell(false);
		this.$chat_element.fadeOut(300);
	}

	should_close(e) {
		const chat_app = $('.chat-app');
		const navbar = $('.navbar');
		const modal = $('.modal');
		return (
			!chat_app.is(e.target) &&
			chat_app.has(e.target).length === 0 &&
			!navbar.is(e.target) &&
			navbar.has(e.target).length === 0 &&
			!modal.is(e.target) &&
			modal.has(e.target).length === 0
		);
	}

	ensure_desk_toast_styles() {
		if (document.getElementById('desk-chat-toast-styles')) {
			return;
		}
		const el = document.createElement('style');
		el.id = 'desk-chat-toast-styles';
		el.textContent = `
.desk-chat-toast-stack{position:fixed;z-index:20000;bottom:16px;right:16px;left:auto;display:flex;flex-direction:column;gap:8px;align-items:flex-end;max-width:min(380px,calc(100vw - 24px));pointer-events:none}
.desk-chat-toast-stack .desk-chat-toast{pointer-events:auto}
.desk-chat-toast{position:relative;width:min(360px,calc(100vw - 24px));padding:10px 38px 12px 12px;background:#fff;color:#1a1d21;border-radius:12px;box-shadow:0 10px 40px rgba(0,0,0,.18),0 0 0 1px rgba(0,0,0,.06);cursor:pointer;text-align:start;animation:deskChatToastIn .28s ease;border-inline-end:4px solid #276bbb}
.desk-chat-toast__close{position:absolute;top:6px;inset-inline-end:6px;width:28px;height:28px;border:none;background:transparent;cursor:pointer;color:#6c757d;border-radius:8px;padding:0;line-height:1;font-size:18px}
.desk-chat-toast__close:hover{background:rgba(0,0,0,.06);color:#1a1d21}
.desk-chat-toast__title{font-weight:700;font-size:14px;line-height:1.35;margin-bottom:4px;word-break:break-word}
.desk-chat-toast__sender{font-size:12px;font-weight:600;color:#495057;margin-bottom:6px}
.desk-chat-toast__preview{font-size:13px;color:#495057;white-space:pre-wrap;word-break:break-word;line-height:1.45}
@keyframes deskChatToastIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
`;
		document.head.appendChild(el);
	}

	get_desk_toast_stack() {
		let s = document.getElementById('desk-chat-toast-stack');
		if (!s) {
			this.ensure_desk_toast_styles();
			s = document.createElement('div');
			s.id = 'desk-chat-toast-stack';
			s.className = 'desk-chat-toast-stack';
			s.setAttribute('aria-live', 'polite');
			document.body.appendChild(s);
		}
		return s;
	}

	show_desk_message_toast(payload) {
		const me = this;
		const esc = (t) =>
			$('<div>')
				.text(t == null ? '' : String(t))
				.html();
		const stack = this.get_desk_toast_stack();
		while (stack.children.length >= 4) {
			stack.removeChild(stack.firstChild);
		}
		const t = document.createElement('div');
		t.className = 'desk-chat-toast';
		t.setAttribute('tabindex', '0');
		const title = esc(payload.title || '');
		const preview = esc(payload.preview || '');
		const sender = esc(payload.sender || '');
		let inner = `<button type="button" class="desk-chat-toast__close" aria-label="بستن">&times;</button>`;
		inner += `<div class="desk-chat-toast__title">${title}</div>`;
		if (payload.isGroup && payload.sender) {
			inner += `<div class="desk-chat-toast__sender">${sender}</div>`;
		}
		inner += `<div class="desk-chat-toast__preview">${preview}</div>`;
		t.innerHTML = inner;
		const roomId = payload.roomId;
		const closeBtn = t.querySelector('.desk-chat-toast__close');
		closeBtn.addEventListener('click', (e) => {
			e.stopPropagation();
			t.remove();
		});
		t.addEventListener('click', (e) => {
			if ($(e.target).closest('.desk-chat-toast__close').length) {
				return;
			}
			t.remove();
			me.activate_desk_toast_room(roomId);
		});
		t.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				t.remove();
				me.activate_desk_toast_room(roomId);
			}
		});
		stack.appendChild(t);
		setTimeout(() => {
			if (t.parentNode) {
				t.remove();
			}
		}, 9000);
	}

	activate_desk_toast_room(roomId) {
		if (!roomId) {
			return;
		}
		if (!this.is_open) {
			this.chat_bubble.change_bubble();
		}
		const me = this;
		setTimeout(() => {
			const iframe = me.$chat_container.find('iframe.chat-widget-iframe')[0];
			if (iframe && iframe.contentWindow) {
				try {
					iframe.contentWindow.postMessage(
						{ type: 'frappe-chat-open-room', room: roomId },
						'*'
					);
				} catch (e) {
					/* ignore */
				}
			}
		}, 400);
	}

	setup_events() {
		const me = this;
		$('.chat-navbar-icon').on('click', function () {
			me.chat_bubble.change_bubble();
		});

		$(window).on('message', function (ev) {
			const d = ev.originalEvent && ev.originalEvent.data;
			if (!d || !d.type) return;
			if (d.type === 'frappe-chat-embed-layout') {
				me.$app_element.toggleClass('chat-app--embed-fullwidth', !!d.fullwidth);
				return;
			}
			if (d.type === 'frappe-chat-unread') {
				const n = parseInt(d.count, 10);
				const badge = $('#chat-notification-count');
				if (!n || n < 1 || isNaN(n)) {
					badge.text('');
					frappe.Chat.settings.unread_count = 0;
				} else {
					badge.text(n > 99 ? '99+' : String(n));
					frappe.Chat.settings.unread_count = n;
				}
				return;
			}
			if (d.type === 'frappe-chat-request-open' && !me.is_open) {
				me.chat_bubble.change_bubble();
				return;
			}
			if (d.type === 'frappe-chat-toast') {
				me.show_desk_message_toast(d);
			}
		});

		$(document).mouseup(function (e) {
			if (me.should_close(e) && me.is_open === true) {
				me.chat_bubble.change_bubble();
			}
		});
	}
};

$(function () {
	new frappe.Chat();
});
